import React from 'react';
import { string, node } from 'prop-types';
import NavigationBar from 'components/DataPanel/NavigationBar';

import styles from './Layout.scss';

function Layout({ title, children, backTo, header }) {
  return (
    <section className={styles.main}>
      <div className={styles.top}>
        <NavigationBar closeTo="/map/live" backTo={backTo} title={title} />
      </div>
      <div className={styles.content}>
        {header}
        <div className={styles.subContent}>
          {children}
        </div>
      </div>
    </section>
  );
}

Layout.propTypes = {
  title: string.isRequired,
  backTo: string.isRequired,
  header: node.isRequired,
  children: node.isRequired,
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Details/Layout/index.js